<template>
  <el-card class="box-card" style="margin-top: 0;padding-top:0;">
    <div style="display:flex;font-size: 18px;line-height: 40px;">
      <b style="flex:1;">{{ isEdit ? '编辑菜单' : '新增菜单' }}</b>
    </div>
    <el-form
      :model="formData"
      ref="menuForm"
      :rules="rules"
      label-width="140px"
      label-position="right"
      style="width: 100%"
    >
      <el-form-item label="上级菜单：" prop="parentName">
        <div>{{ formData.parentName || '根菜单' }}</div>
      </el-form-item>
      <el-form-item label="菜单名称：" prop="name">
        <el-input v-model.trim="formData.name" placeholder="请输入菜单名称" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="菜单类型：" prop="type">
        <el-radio-group v-model="formData.type">
          <el-radio :label="1">模块</el-radio>
          <el-radio :label="2">菜单</el-radio>
          <el-radio :label="3">按钮</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="权限码：" prop="authCode">
        <el-input v-model.trim="formData.authCode" placeholder="请输入权限码" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="菜单地址：" prop="menuUrl">
        <el-input v-model.trim="formData.menuUrl" placeholder="请输入菜单地址" maxlength="200"></el-input>
      </el-form-item>
      <el-form-item label="图标：" prop="icon">
        <el-input v-model.trim="formData.icon" placeholder="请输入图标类名，如：el-icon-menu" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="排序：" prop="sort">
        <el-input-number v-model="formData.sort" :min="0" :max="9999" controls-position="right" placeholder="请输入排序值"></el-input-number>
      </el-form-item>
      <el-form-item label="系统标识：" prop="sysFlag">
        <el-select v-model="formData.sysFlag" placeholder="请选择系统标识" clearable>
          <el-option label="门户中心" value="homePage"></el-option>
          <el-option label="供需通" value="gongxutong"></el-option>
          <el-option label="医修保" value="yxb"></el-option>
          <el-option label="1械网" value="1xie"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联接口地址：" prop="authUrl">
        <el-input
          type="textarea"
          v-model.trim="formData.authUrl"
          placeholder="请输入所关联的接口地址（多条用逗号分隔）"
          :rows="3"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="description">
        <el-input
          type="textarea"
          v-model.trim="formData.description"
          placeholder="请输入描述"
          :rows="2"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item class="btnsContainer">
        <el-button type="default" @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'MenuForm',
  props: {
    menuInfo: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      formData: {},
    };
  },
  computed: {
    rules () {
      return {
        name: [
          {
            required: true,
            message: '菜单名称不可为空',
            trigger: ['blur', 'change'],
          },
          {
            max: 50,
            message: '菜单名称不可超过50个字符',
            trigger: ['blur', 'change'],
          },
        ],
        type: [
          {
            required: true,
            message: '请选择菜单类型',
            trigger: ['blur', 'change'],
          },
        ],
        authCode: [
          {
            required: true,
            message: '权限码不可为空',
            trigger: ['blur', 'change'],
          },
          {
            max: 100,
            message: '权限码不可超过100个字符',
            trigger: ['blur', 'change'],
          },
        ],
      };
    },
  },
  watch: {
    menuInfo: {
      handler (val) {
        this.formData = JSON.parse(JSON.stringify(val));
        this.$nextTick(() => {
          this.$refs.menuForm && this.$refs.menuForm.clearValidate();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleCancel () {
      this.$emit('cancel');
    },
    handleSave () {
      this.$refs.menuForm.validate((valid) => {
        if (!valid) {
          return false;
        }

        const params = {
          authCode: this.formData.authCode,
          authUrl: this.formData.authUrl || '',
          description: this.formData.description || '',
          icon: this.formData.icon || '',
          menuUrl: this.formData.menuUrl || '',
          name: this.formData.name,
          pid: this.formData.pid,
          sort: this.formData.sort || 0,
          sysFlag: this.formData.sysFlag || '',
          type: this.formData.type,
        };

        this.$emit('save', params);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box-card {
  ::v-deep .el-card__body {
    padding: 20px;
  }
}

.btnsContainer {
  margin-top: 30px;
  text-align: right;
}
</style>
